import React, { useCallback } from 'react';
import { Input } from '@byte-design/ui';
import { Search as SearchBtn } from '@icon-park/react';
import { observer, useLocalStore } from 'mobx-react';
import Styles from './index.module.scss';

function Search() {
  const State = useLocalStore(() => ({
    value: '',
    isShow: false,
  }));
  const SearchSomething = useCallback(() => {

  }, []);

  return (
    <div className={`${Styles.container} ${State.isShow && Styles.active}`}>
      <Input
        className={Styles.input}
        onValueChange={(val) => { State.value = val; }}
        value={State.value}
        onFocus={() => { State.isShow = true; }}
        onBlur={() => { State.isShow = false; }}
        onPressEnter={SearchSomething}
        suffix={(<SearchBtn />)}
      />
      <div className={Styles.icon}>
        <SearchBtn size="16" fill="#eee" />
      </div>
    </div>
  );
}

export default React.memo(observer(Search));
